import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { styled } from "@mui/material";

import { jwt } from "../utils/index.js";

const PREFIX = "DifferentAccess";

const classes = {
    main: `${PREFIX}-main`,
    mainBox: `${PREFIX}-mainBox`
};

const StyledNavigateDiv = styled("div")(({ theme }) => ({
    [`&.${classes.main}`]: {
		width: "100%",
		height: "calc(100% - 100px)",
		backgroundColor: theme.palette.white.main,
		position: "fixed",
	},

    [`& .${classes.mainBox}`]: {
		padding: "10px 20px",
		overflowY: "auto",
		position: "absolute",
		display: "flex",
		height: "100%",
		maxHeight: "100%",
		flexWrap: "wrap",
	}
}));

const maybeSetToken = (Component) => (props) => {
	const { search } = useLocation();
	const { token } = queryString.parse(search);
	if (token) jwt.setToken(token);
	return <Component {...props} />;
};

const DifferentAccess = ({ AuthenticatedComponent, UnauthenticatedComponent }) => (
	<StyledNavigateDiv className={classes.main}>
		<div className={classes.mainBox} style={{ width: "100%", overflowY: "auto" }}>
			<div className="header-container">
				{jwt.isAuthenticated() ? (
					<AuthenticatedComponent />
				) : (
					<UnauthenticatedComponent />
				)}
			</div>
		</div>
	</StyledNavigateDiv>
);

export default maybeSetToken(DifferentAccess);

